import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Modal, notification, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView,
    watchRulesChildren
} from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { has, have } from "../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionOpenUrl,
    createRowActionReStatus,
    createRowActionView
} from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { required, requiredWhen, validateError } from "../../../../utils/validate";
import { openModalForm as openModalFormConfirmApprove } from "../../storage-location/request/modal/confirm-approve.logic";
import { openModalForm as openModalFormConfirmReceive } from "../../storage-location/request/modal/confirm-receive.logic";
import { openModalForm as openModalFormConfirmRequest } from "../../storage-location/request/modal/confirm-request.logic";
import { callRequestDoc, callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import {
    callRequestDocGenType,
    callUser,
    callUserCompanyMe,
    checkUserCompanyOperation
} from "../../storage-location/request/requestor/requestor.section";
import { createForm as createFormHaz } from "../haz/haz.logic";
import { callHazSubStanceType, callHazType } from "./haz-info/haz-info.section";
import { calSubStanceRate } from "./haz-info/haz-main-sub-stance.logic";
import { callPictogram } from "./haz-pictogram/haz-pictogram.section";
import { createConditionAction, createConditionForm } from "./request.condition";
import {
    callHazAttachment,
    callHazReserveWord,
    callUserObjective,
    createColumns,
    createField,
    // hazDuplicateWordRule,
    hazReserveWordRule,
    isOperationAndSubStanceTypeMain,
    requiredSolidOrLiquid
} from "./request.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReStatus = ({ data }) => store.dispatch(`${actionPrefix}/reStatus`, { data });
export const callReportHaz = ({ data }) => store.dispatch(`${actionPrefix}/reportHaz`, { data });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const companyNameThIndex = customWhere.findIndex(d => d.name === "refHazTemp.refUserCompany.companyNameTh");
    if (companyNameThIndex !== -1) {
        const companyNameThWhere = customWhere[companyNameThIndex];
        customWhere.splice(
            companyNameThIndex,
            1,
            {
                openBucket: true,
                name: "refHazTemp.refUserCompany.companyNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refHazTemp.refUserCompany.fullNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            }
        );
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const validate = ({ props, data, refs }) => {
    const { menuContext } = props;
    const rulesTop = createRulesTop({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules2 = createRulesTab2({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });
    const rules4 = createRulesTab4({ props, data, refs });
    const rules5 = createRulesTab5({ props, data, refs });
    const rules6 = createRulesTab6({ props, data, refs });
    const rules7 = createRulesTab7({ props, data, refs });
    const rules8 = createRulesTab8({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesTop))
        .then(() => {
            tabKey = "Requestor";
            return data.useForm.validate(Object.keys(rules1));
        })
        .then(() => {
            tabKey = "HazInfo";
            return data.useForm.validate(Object.keys(rules2));
        })
        .then(() => {
            tabKey = "HazPictogram";
            return data.useForm.validate(Object.keys(rules3));
        })
        .then(() => {
            tabKey = "HazPackage";
            return data.useForm.validate(Object.keys(rules4));
        })
        .then(() => {
            tabKey = "HazTest";
            return data.useForm.validate(Object.keys(rules5));
        })
        .then(() => {
            tabKey = "HazUseRate";
            return data.useForm.validate(Object.keys(rules6));
        })
        .then(() => {
            tabKey = "HazDistributor";
            return data.useForm.validate(Object.keys(rules7));
        })
        .then(() => {
            tabKey = "Attachment";
            return data.useForm.validate(Object.keys(rules8));
        })
        .catch(error => {
            if (tabKey) {
                menuContext.tabKey = tabKey;
            }
            validateError({ error });
            throw error;
        });
};

export const onClickSave = ({ props, data, refs, formParams, successText }) => {
    const { viewOnly, routerPrefix } = props;
    return validate({ props, data, refs }).then(() => {
        setIsLoadingApp(true);
        data.useForm.modelRef.refHazTemp?.mainSubStances?.filter(d => d.isDelete !== true)?.forEach(d => (d.isSave = true));
        return callRequest({ form: { ...data.useForm.modelRef, ...formParams } })
            .finally(() => setIsLoadingApp(false))
            .then(record => {
                if (successText) notification["success"]({ message: successText });
                if (viewOnly) initForm({ props, data, refs });
                else onClickView({ record, routerPrefix });
            });
    });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: [
                "**",
                "refHaz.id",
                "refHaz.approveCode",
                "refHaz.effectiveDate",
                "refHaz.expireDate",
                "refHaz.refUserCompany.*",
                "refHaz.refUserCompany.refPersonType.*",
                "refHazTemp.**",
                "refHazTemp.refUserCompany.**",
                "refHazTemp.refUser.**",
                "refHazTemp.refHazObject.**"
            ],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "refHazTemp.refUserCompany.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "refHazTemp.refUserCompany.userObjectives",
                    select: ["*", "refObjective.*"],
                    page: 0,
                    size: 1000000
                },
                {
                    name: "refHazTemp.refUser.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "refHazTemp.products",
                    select: ["*", "refProduct.*", "refProduct.refParent.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "refHazTemp.pictograms",
                    select: ["*", "refPictogram.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "statuses",
                    asName: "lastStatus.draft",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "draft" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitReceive",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitReceive" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitApprove",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitApprove" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.approve",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forRequestRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forReceiveRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "feeStatements",
                    select: ["*", "refType.*", "refStatus.*"],
                    page: 0,
                    size: 1,
                    sort: [{ name: "createDate", type: "DESC" }],
                    children: []
                }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    if (has({ menuContext, key: "forRequest" })) {
        whereGroup.push([{ name: "refHazTemp.refUser.username", type: "String", operator: "=", value: userInfo.username }]);
        if (userInfo.isCeo) {
            whereGroup.push([{ name: "refHazTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id }]);
        }
    }
    if (has({ menuContext, key: "forReceive" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "!=", value: "draft" },
            { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id }
        ]);
    }
    if (has({ menuContext, key: "forApprove" })) {
        whereGroup.push([{ name: "refToApproveBy.username", type: "String", operator: "=", value: userInfo.username }]);
    }
    if (has({ menuContext, key: "canViewAll" })) {
        whereGroup.push([{ name: "refStatus.key", type: "String", operator: "!=", value: "draft" }]);
    }
    return [
        { name: "refRequestDoc.key", type: "String", operator: "in", value: ["04", "05"] },
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ];
};

export const createForm = () => {
    return {
        model: null,
        refModelId: null,
        refModelTempId: null,
        refRequestType: null,
        refRequestDoc: null,
        refStatus: null,
        draftCode: null,
        requestCode: null,
        refDepartment: null,
        isSignCa: null,
        refHaz: null,
        refHazTemp: { ...createFormHaz() },
        lastStatus: {
            draft: [{ remark: null, statusDatetime: null }],
            waitReceive: [{ remark: null, statusDatetime: null }],
            waitApprove: [{ remark: null, statusDatetime: null }],
            approve: [{ remark: null, statusDatetime: null }],
            forRequestRemark: [{ remark: null, statusDatetime: null }],
            forReceiveRemark: [{ remark: null, statusDatetime: null }]
        }
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTop({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab2({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key }),
        ...createRulesTab4({ props, data, refs, key }),
        ...createRulesTab5({ props, data, refs, key }),
        ...createRulesTab6({ props, data, refs, key }),
        ...createRulesTab7({ props, data, refs, key }),
        ...createRulesTab8({ props, data, refs, key })
    };
};

export const createRulesTop = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDocGenType`]: [required],
        [`${prefix}refRequestType`]: [required],
        [`${prefix}refHaz`]: [requiredWhen({ when: () => ["2", "3", "4"].includes(model.refRequestType?.key) })],
        [`${prefix}refHazTemp.refOperation`]: [required],
        [`${prefix}refHazTemp.effectiveDate`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}refHazTemp.approveManualDate`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}lastStatus.forRequestRemark.0.remark`]: [requiredWhen({ when: () => !model.isOfficerCreate && ["2", "4"].includes(model.refRequestType?.key) && (!model.id || ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(model.refStatus?.key)) })]
    };
};

export const createRulesTab1 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDepartment`]: [required],
        [`${prefix}refHazTemp.refUserCompany`]: [requiredWhen({ when: () => true, requiredValidator: () => model.refHazTemp.refUserCompany?.id })],
        [`${prefix}refHazTemp.refUser`]: [requiredWhen({ when: () => true, requiredValidator: () => model.refHazTemp.refUser?.id })]
    };
};

export const createRulesTab2 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazTemp.refHazObject`]: [required],
        [`${prefix}refHazTemp.tradeNameTh`]: [
            required,
            hazReserveWordRule({ data, key: `${prefix}refHazTemp`, valueKey: "value" }),
            // hazDuplicateWordRule({ data, key: `${prefix}refHazTemp`, tradeNameKey: "tradeNameTh" })
        ],
        [`${prefix}refHazTemp.tradeNameEn`]: [
            required,
            hazReserveWordRule({ data, key: `${prefix}refHazTemp`, valueKey: "value2" }),
            // hazDuplicateWordRule({ data, key: `${prefix}refHazTemp`, tradeNameKey: "tradeNameEn" })
        ],
        [`${prefix}refHazTemp.isLiquid`]: [requiredSolidOrLiquid({ data, key })],
        [`${prefix}refHazTemp.refSubStanceType`]: [required],
        [`${prefix}refHazTemp.manufacturer`]: [required],
        [`${prefix}refHazTemp.refManufactureCountry`]: [required],
        [`${prefix}refHazTemp.refType`]: [required],
        [`${prefix}refHazTemp.toUse`]: [requiredWhen({ when: () => model.refHazTemp.refType?.key === "1" })],
        [`${prefix}refHazTemp.products`]: [requiredWhen({ when: () => model.refHazTemp.refType?.key === "2" })],
        [`${prefix}refHazTemp.refSubStanceTypeMain`]: [required],
        [`${prefix}refHazTemp.refAnalysisAgency`]: [required],
        [`${prefix}refHazTemp.refAnalysisMethod`]: [required],
        [`${prefix}refHazTemp.refSubStanceActive`]: [requiredWhen({ when: () => model.refHazTemp.isSubStanceActive })],
        [`${prefix}refHazTemp.analysisResult`]: [
            requiredWhen({
                when: () => model.refHazTemp.isSubStanceActive,
                requiredValidator: ({ rule, value }) => {
                    return required.validator(rule, value).then(() => {
                        // type must change from refSubStanceActive.isSolid = '1' or refSubStanceActive.isLiquid = '2'
                        const type = model?.refHazTemp?.isLiquid === true ? "2" : "1";
                        const rate = calSubStanceRate({ type: type, qty: model.refHazTemp.subStanceMainQty });
                        const result = model.refHazTemp.analysisResult;
                        if (result < rate?.min || result > rate?.max) {
                            return Promise.reject(i18n.global.t("views.request.hazInfo.error.refMainSubStanceRate"));
                        }
                        return Promise.resolve();
                    });
                }
            })
        ],
        [`${prefix}refHazTemp.subStanceMainQty`]: [requiredWhen({ when: () => model.refHazTemp.isSubStanceActive })],
        [`${prefix}refHazTemp.refSubStanceMainUnit`]: [requiredWhen({ when: () => model.refHazTemp.isSubStanceActive })],
        [`${prefix}refHazTemp.mainSubStances`]: [required]
    };
    model?.refHazTemp?.mainSubStances?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.mainSubStances.${index}.refSubStance`] = [required];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.intense`] = [required];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.chemiAnalysisResult`] = [
                requiredWhen({
                    when: () =>
                        !model.refHazTemp.isSubStanceActive &&
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true })) &&
                        item.refSubStance?.refType?.key !== "media",
                    requiredValidator: ({ rule, value }) => {
                        return required.validator(rule, value).then(() => {
                            if (item.isBypassAnalysisResult) {
                                return Promise.resolve();
                            }
                            if (
                                isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                                isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                                isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false })
                            ) {
                                // type must change from refSubStance.isSolid = '1' or refSubStance.isLiquid = '2'
                                const type = model?.refHazTemp?.isLiquid === true ? "2" : "1";
                                const rate = calSubStanceRate({ type: type, qty: model.refHazTemp.mainSubStances[index].qty });
                                const result = model.refHazTemp.mainSubStances[index].chemiAnalysisResult;
                                if (result < rate?.min || result > rate?.max) {
                                    return Promise.reject(i18n.global.t("views.request.hazInfo.error.refMainSubStanceRate"));
                                }
                            }
                            if (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true })) {
                                const qty = model.refHazTemp.mainSubStances[index].qty;
                                const result = model.refHazTemp.mainSubStances[index].chemiAnalysisResult;
                                if (result < qty) {
                                    return Promise.reject(i18n.global.t("views.request.hazInfo.error.refMainSubStanceRate"));
                                }
                            }
                            return Promise.resolve();
                        });
                    }
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.qty`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true })) &&
                        item.refSubStance?.refType?.key !== "media" &&
                        !model.refHazTemp.isSubStanceActive
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.refUnit`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                        item.refSubStance?.refType?.key !== "media" &&
                        !model.refHazTemp.isSubStanceActive
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisResult1`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisResult2`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisResult3`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisQty1`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisQty2`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.microAnalysisQty3`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.refMicroUnit`] = [
                requiredWhen({
                    when: () =>
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.companies`] = [
                requiredWhen({
                    when: () =>
                        model.refHazTemp.mainSubStances[index].isImport &&
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.products`] = [
                requiredWhen({
                    when: () =>
                        model.refHazTemp.mainSubStances[index].isImport &&
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.docNoRefer`] = [
                requiredWhen({
                    when: () =>
                        model.refHazTemp.mainSubStances[index].isInternal &&
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
            rules[`${prefix}refHazTemp.mainSubStances.${index}.attachments.0`] = [
                requiredWhen({
                    when: () =>
                        model.refHazTemp.mainSubStances[index].isInternal &&
                        (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                            isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                        item.refSubStance?.refType?.key !== "media"
                })
            ];
        }
    });
    return rules;
};

export const createRulesTab3 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazTemp.pictograms`]: [required]
    };
    model?.refHazTemp?.aquatics?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.aquatics.${index}.refAquaticType`] = [required];
            rules[`${prefix}refHazTemp.aquatics.${index}.refSubAquaticType`] = [required];
        }
    });
    return rules;
};

export const createRulesTab4 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazTemp.packages`]: [required]
    };
    model?.refHazTemp?.packages?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.packages.${index}.refPackage1`] = [required];
        }
    });
    return rules;
};

export const createRulesTab5 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazTemp.tests`]: [required]
    };
    model?.refHazTemp?.tests?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.tests.${index}.refAnalysisAgency`] = [required];
        }
    });
    return rules;
};

export const createRulesTab6 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazTemp.useRates`]: [required]
    };
    model?.refHazTemp?.useRates?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.useRates.${index}.useRate`] = [required];
        }
    });
    return rules;
};

export const createRulesTab7 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refHazTemp?.distributors?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.distributors.${index}.refDistributor`] = [required];
        }
    });
    return rules;
};

export const createRulesTab8 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refHazTemp?.attachments?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazTemp.attachments.${index}.documentName`] = [required];
            rules[`${prefix}refHazTemp.attachments.${index}.size`] = [
                requiredWhen({
                    when: () =>
                        model.refHazTemp.attachments[index].attribute?.isRequiredAttachment ||
                        model.refHazTemp.attachments[index].attribute?.documentNo
                })
            ];
        }
    });
    return rules;
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.refRequestDoc?.value} (${modelRef.refStatus?.value})` : i18n.global.t("button.create");
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callHazAttachment({}),
        callRequestStatus({}),
        callHazType({}),
        callHazSubStanceType({}),
        callRequestType({}),
        callRequestDoc({}),
        callUserObjective({}),
        callPictogram({}),
        callRequestDocGenType({}),
        callHazReserveWord({})
    ];
    return Promise.all(promises).then(arr => {
        data.hazAttachments = arr[0];
        data.statuses = arr[1];
        data.hazTypes = arr[2];
        data.hazSubStanceTypes = arr[3];
        data.requestTypes = arr[4];
        data.requestDocs = arr[5];
        data.userObjectives = arr[6];
        data.pictograms = arr[7];
        data.requestDocGenTypes = arr[8];
        data.hazReserveWords = arr[9];
        const userInfo = store.state.resource.auth.info?.user;

        if ((!id && !form) || forceDefault) {
            modelRef.isOfficerCreate = !!userInfo.refOfficerLv;
            if (!modelRef.isOfficerCreate) {
                callUserCompanyMe({}).then(userCompanies => {
                    const refUserCompany = userCompanies[0];
                    modelRef.refHazTemp.refUserCompany = refUserCompany;
                    if (refUserCompany) {
                        callUser({ userCompanyId: refUserCompany.id }).then(
                            users => (modelRef.refHazTemp.refUser = users.find(d => d.id === userInfo?.id))
                        );
                        modelRef.refHazTemp.refOperation = checkUserCompanyOperation({
                            operations: data.userObjectives,
                            userCompany: refUserCompany
                        })[0];
                        data.onUpdateRefOperation?.(modelRef.refHazTemp.refOperation);
                    }
                });
            }
            modelRef.refHazTemp.refType = data.hazTypes.find(d => d.key === "1");
            modelRef.refHazTemp.refSubStanceTypeMain = data.hazSubStanceTypes.find(d => d.key === "chemi");
            modelRef.lastStatus.draft[0].statusDatetime = moment().format("YYYY-MM-DD[T]HH:mm:ssZ");
            data.hazAttachments.forEach(item =>
                modelRef.refHazTemp.attachments.push({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
            );
            modelRef.refRequestType = data.requestTypes.find(d => d.key === "1");
            modelRef.refRequestDoc = data.requestDocs.find(d => d.key === "04");
            modelRef.refDocGenType = data.requestDocGenTypes.find(d => d.key === "1");
            modelRef.refHazTemp.isTechnicalGrade = false;
        }
    });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canArchive({ props, record }) })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        }),
        createRowActionReStatus({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.reStatus") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        setIsLoadingApp(true);
                        callReStatus({ data: record })
                            .finally(() => setIsLoadingApp(false))
                            .then(() => onSearch({ props, page: state.page }));
                    }
                });
            },
            visible: ({ record }) => state.conditionAction.canReStatus({ props, record })
        }),
        /*
        createRowActionPdf({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callReport: ({ record }) => callReportHaz({ data: { id: record.id } }),
            fileName: "report.pdf"
        }),
        */
        createRowActionOpenUrl({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callUrl: ({ record }) => `${process.env.VUE_APP_API_REPORT_URL}/files/haz/company/${record.id}/file-result.pdf?contentDisposition=inline&_timestamp=${new Date().getTime()}`,
            visible: ({ record }) => state.conditionAction.canReport({ props, record })
        })
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    data.userInfo = store.state.resource.auth.info?.user;
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazTemp.mainSubStances.filter(d => d.isDelete !== true).length +
            data.useForm.modelRef.refHazTemp.mainSubStances.filter(d => d.isDelete !== true && d.isBypassAnalysisResult).length,
        createRules: () => createRulesTab2({ props, data, refs }),
        itemsKey: "refHazTemp.mainSubStances"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazTemp.packages.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab4({ props, data, refs }),
        itemsKey: "refHazTemp.packages"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazTemp.tests.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab5({ props, data, refs }),
        itemsKey: "refHazTemp.tests"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazTemp.useRates.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab6({ props, data, refs }),
        itemsKey: "refHazTemp.useRates"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazTemp.attachments.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab8({ props, data, refs }),
        itemsKey: "refHazTemp.attachments"
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive, feeStatements } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canWaitReceive = state.conditionAction.canWaitReceive({ props, record: initialModel });
    const canWaitApprove = state.conditionAction.canWaitApprove({ props, record: initialModel });
    const canHsss = state.conditionAction.canHsss({ props, record: initialModel });
    const canApprove = state.conditionAction.canApprove({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButtonSave({
                onClick: () => {
                    data.sendReceive = false;
                    const refHazTemp = modelRef.refHazTemp;
                    let statusRemark = null;
                    if ([undefined, "draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forRequestRemark[0].remark;
                    } else if (["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forReceiveRemark[0].remark;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        formParams: {
                            refHazTemp: {
                                ...modelRef.refHazTemp,
                                refUserCompany: refHazTemp?.refUserCompany?.id ? refHazTemp?.refUserCompany : null,
                                refUser: refHazTemp?.refUser?.id ? refHazTemp?.refUser : null
                            },
                            statusRemark
                        }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (id && isActive && canWaitReceive) {
        const statusWaitReceive = data.statuses.find(status => status.key === "waitReceive");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusWaitReceive?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitReceive?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmRequest({
                            onOk: record => {
                                const refHazTemp = modelRef.refHazTemp;
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams: {
                                        refHazTemp: {
                                            ...modelRef.refHazTemp,
                                            refUserCompany: refHazTemp?.refUserCompany?.id ? refHazTemp?.refUserCompany : null,
                                            refUser: refHazTemp?.refUser?.id ? refHazTemp?.refUser : null
                                        },
                                        statusRemark: modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: modelRef.lastStatus.forRequestRemark[0].remark,
                                        refStatus: statusWaitReceive,
                                        isSignCa: record.isSignCa,
                                        passwordCa: record.passwordCa
                                    },
                                    successText: i18n.global.t("views.request.modal.request.sendSuccess")
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canWaitApprove) {
        const statusWaitApprove = data.statuses.find(status => status.key === "waitApprove");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmReceive({
                            props: {
                                roleName: "HAZ_APPROVE",
                                statusKeys: modelRef.isOfficerCreate ? ["waitApprove"] : []
                            },
                            onOk: record => {
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams: {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack ? modelRef.lastStatus.forReceiveRemark[0].remark : null,
                                        refStatus: record.refStatus,
                                        refToApproveBy: record.refToApproveBy
                                    },
                                    successText: i18n.global.t(`views.request.modal.receive.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canApprove) {
        const statusApprove = data.statuses.find(status => status.key === "approve");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmApprove({
                            onOk: record => {
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams: {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack ? modelRef.lastStatus.forReceiveRemark[0].remark : null,
                                        refStatus: record.refStatus
                                    },
                                    successText: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && canHsss) {
        col2.push(
            createButton({
                text: i18n.global.t("button.hsss"),
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    Modal[modelRef.hsssResponse ? "info" : "error"]({
                        content: <pre>{(modelRef.hsssResponse ? JSON.stringify(modelRef.hsssResponse) : null) || modelRef.hsssError}</pre>,
                        width: 800
                    });
                }
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    if (
        id &&
        feeStatements?.[0]?.id &&
        ((has({ menuContext, key: "forRequest" }) && ![undefined, "draft"].includes(feeStatements?.[0]?.refStatus?.key)) ||
            have({ menuContext, keys: ["forReceive", "forApprove"] }))
    ) {
        col2.push(
            createButton({
                text: `${i18n.global.t("model.feeStatement.modelName")}${feeStatements?.[0] ? ` (${feeStatements[0].refStatus?.value})` : ""}`,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        router.push({ name: `fees-view`, params: { id: feeStatements?.[0]?.id } });
                    });
                },
                icon: <CIcon file="active.svg"></CIcon>
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [
                "*",
                "refHaz.*",
                "refHazTemp.*",
                // "refHazNew.*",
                "refHazMax.id",
                "refHazMax.approveCode",
                "refHazMax.approveCode2",
                "refHazMax.effectiveDate",
                "refHazMax.expireDate",
                "refHazTemp.refUserCompany.*",
                "refHazTemp.refUserCompany.refPersonType.*",
                "refHazTemp.refUser.*",
                "refHazTemp.refType.*",
                "refHazTemp.refHazObject.*",
                "refHazTemp.refOperation.*",
                "refRequestType.*",
                "refStatus.*",
                "refWaitReceiveStatus.*",
            ],
            sort: [/* { name: "refStatus.seq", type: "ASC" } ,*/{ name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
